import { createSelector } from 'reselect';

const getGroups = (state) => state.budgetsApp.budgetGroups;
const getCards = (state) => state.budgetsApp.workers;

export const getBudgetGroups = createSelector(
    [getGroups, getCards],
    (groups, cards) => {
        return groups.map((group) => {
            return { ...group, cards: cards.filter(card => group.id === card.budgetGroupId).length };
        });
    }
);

export const getBudgetCards = createSelector(
    [getGroups, getCards],
    (groups, cards) => {
        return cards.map((card) => {
            return { ...card, budgetGroup: groups.find(group => group.id === card.budgetGroupId) };
        });
    }
);

